import { useRouter } from 'next/router';
import Head from 'next/head';
import { Layout } from '@stitch-fix/sf-next';
import type { NextPage } from 'next';
import { OnboardingFailed, ProfilePhotos } from '../../../features/vision';
import { useGetVisionStatusQuery } from '../../../utils/hooks/getVisionStatus';
const GalleryPage: NextPage = () => {
  const router = useRouter();
  const {
    data,
    loading
  } = useGetVisionStatusQuery();
  const visionNotificationParam = router.query?.visionNotification;
  const shouldForceOnboardingFailed = Array.isArray(visionNotificationParam) ? visionNotificationParam.includes('true') : visionNotificationParam === 'true';
  const businessLine = data?.client?.businessLine;
  const onboardingFailedMessage = data?.client?.vision?.onboardingFailedMessage ?? undefined;
  if (loading) {
    return null;
  }
  return <Layout responsiveSection={{
    mt: 1.5,
    gutter: 'none'
  }}>
      <Head>
        <title>Profile Photos | Stitch Fix</title>
      </Head>
      {shouldForceOnboardingFailed ? <OnboardingFailed businessLine={businessLine === 'MENS' || businessLine === 'WOMENS' ? businessLine : 'WOMENS'} onboardingFailedMessage={onboardingFailedMessage} showOnboarderHeader={false} /> : <ProfilePhotos />}
    </Layout>;
};
export default GalleryPage;